import { render } from "./CatListSingle.vue?vue&type=template&id=5a123cfe"
import script from "./CatListSingle.vue?vue&type=script&lang=js"
export * from "./CatListSingle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__